// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/Projects/adv/adv_manag_panel/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CarOutlined from 'D:/Projects/adv/adv_manag_panel/node_modules/@ant-design/icons/es/icons/CarOutlined';
import UserOutlined from 'D:/Projects/adv/adv_manag_panel/node_modules/@ant-design/icons/es/icons/UserOutlined';
import DesktopOutlined from 'D:/Projects/adv/adv_manag_panel/node_modules/@ant-design/icons/es/icons/DesktopOutlined';
import DollarOutlined from 'D:/Projects/adv/adv_manag_panel/node_modules/@ant-design/icons/es/icons/DollarOutlined';
import PieChartOutlined from 'D:/Projects/adv/adv_manag_panel/node_modules/@ant-design/icons/es/icons/PieChartOutlined';
export default { SmileOutlined, CarOutlined, UserOutlined, DesktopOutlined, DollarOutlined, PieChartOutlined };
